import { getApiSLice } from "utils/getApiBaseQuery";

export const messagesApiSlice = getApiSLice("dev").injectEndpoints({
  endpoints: (builder) => ({
    getChatsList: builder.query({
      query: ({ page, isControlCenter, reportId }) => ({
        url: `/backOffice/GetChatsList?page=${page}&isControlCenter=${isControlCenter}${
          reportId ? `&reportId=${reportId}` : ""
        }`,
        method: "GET",
      }),
      providesTags: ["Chats"],
    }),
    getChatMessages: builder.query({
      query: ({ page, reportId }) => ({
        url: `/backOffice/GetChatMasseges?page=${page}${
          reportId ? `&reportChatId=${reportId}` : ""
        }`,
        method: "GET",
      }),
      providesTags: ["Messages"],
    }),
    sendMessage: builder.mutation({
      query: (message) => ({
        url: `/backOffice/AddChatMessage`,
        method: "POST",
        body: {
          ...message,
        },
      }),
      invalidatesTags: ["Messages", "Chats"],
    }),
    getControllerUnreadMessageCount: builder.query({
      query: () => ({
        url: `/backOffice/GetControllerUnreadMessageCount`,
        method: "GET",
      }),
      providesTags: ["Messages", "Chats"],
    }),
    MarkChatAsSeen: builder.mutation({
      query: (chat) => ({
        url: `/backOffice/MarkChatAsSeen`,
        method: "POST",
        body: {
          ...chat,
        },
      }),
      invalidatesTags: ["Messages", "Chats"],
    }),
  }),
});

export const {
  useGetChatsListQuery,
  useGetChatMessagesQuery,
  useSendMessageMutation,
  useGetControllerUnreadMessageCountQuery,
  useMarkChatAsSeenMutation,
} = messagesApiSlice;
